export const SET_TRANSACTIONS = 'SET_TRANSACTIONS'



// WEBPACK FOOTER //
// ./src/store/modules/billing/types.js